import { TextField, InputLabel, InputAdornment, Button } from "@mui/material";
import { PasswordInput } from "../components/PasswordInput";
import React, { useState, useEffect, useCallback } from "react";
import "../styles/authorization.scss";
import { IMaskInput } from 'react-imask';
import { auth } from '../components/api';
import Cookies from 'universal-cookie';
import axios from "axios";

const PhoneMask = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="(000) 000-00-00"
            definitions={{
                '#': /[1-9]/,
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

export const Authorization = React.forwardRef((props, ref) => {

    const [phone, setPhone] = useState(null);
    const [password, setPassword] = useState(null);
    const [notificationMessage, setNotificationMessage] = useState("");

    const login = async () => {
        const unmaskedPhone = "7" + phone?.replace(/\D/g, '');
        if (unmaskedPhone.length === 11 && password.length > 7) {
            try {
                const token = await auth(unmaskedPhone, password);
                const cookies = new Cookies();
                cookies.set('token', token, { path: '/' });
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                window.location.href = "/";
            }
            catch {
                setNotificationMessage("* Неверный номер телефона или пароль");
            }
        }
        else {
            setNotificationMessage("* Введите корректный номер телефона или пароль");
        }
    }

    const formatPhone = (inputPhone) => {
        return `+7${inputPhone.replace(/[^0-9+]/g, '')}`
    }

    React.useImperativeHandle(ref, () => ({
        getData: () => {
            return {
                phone: formatPhone(phone),
                password: password
            }
        }
    }));

    const [errors, setErrors] = useState({
        phone: "",
        password: ""
    });

    const validateField = (fieldName, value) => {
        let error = "";

        switch (fieldName) {
            case 'phone':
                error = validatePhone(value);
                break;
            case 'password':
                error = validatePassword(value);
                break;
            default:
                break;
        }

        setErrors(prev => ({
            ...prev,
            [fieldName]: error
        }));
    };

    const validateForm = useCallback(() => {
        const newErrors = {
            phone: validatePhone(phone),
            password: validatePassword(password),
        };

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(error => error !== "");

        return !hasErrors;
    }, [phone, password]);

    const validatePhone = (phoneNumber) => {

        if (!phoneNumber?.trim()) {
            return "Номер телефона обязателен для заполнения";
        }

        const cleanPhone = phoneNumber.replace(/[()\s-]/g, '');

        if (cleanPhone.length !== 10) {
            return "Номер телефона должен содержать 10 цифр";
        }

        const phoneRegex = /^\d+$/;
        if (!phoneRegex.test(cleanPhone)) {
            return "Номер телефона должен содержать только цифры";
        }

        return "";
    };

    const validatePassword = (pass) => {

        if (!pass) {
            return "Пароль обязателен для заполнения";
        }

        if (pass.length < 8) {
            return "Пароль должен содержать минимум 8 символов";
        }

        return "";
    };

    const handlePhoneChange = (event) => {
        const value = event.target.value;
        setPhone(value);
        validateField('phone', value);
    };

    const handlePasswordChange = (event) => {
        const value = event.target.value;
        setPassword(value);
        validateField('password', value);
    };

    useEffect(() => {
        validateForm();
    }, [phone, password, validateForm]);

    return (
        <div className="authorization__main">
            <TextField
                value={phone ?? ""}
                onChange={handlePhoneChange}
                label="Номер телефона"
                className="authorization__input-field"
                error={!!errors.phone && phone !== null}
                helperText={phone !== null && errors.phone}
                slotProps={{
                    input: {
                        inputComponent: PhoneMask,
                        startAdornment: <InputAdornment position="start">+7</InputAdornment>
                    },
                }}
                required
            />
            <PasswordInput
                label="Пароль"
                className="authorization__input-field"
                value={password ?? ""}
                onChange={handlePasswordChange}
                error={!!errors.password && password !== null}
                helperText={password !== null && errors.password}
                required
                fullWidth
                margin="normal"
            />
            {(notificationMessage !== "" ? <InputLabel className="authorization__errorAuth">{notificationMessage}</InputLabel> : "")}
            <Button className="authorization__enter" variant="contained" onClick={() => login()}>Войти</Button>
            <div className="authorization__additional-buttons">
                <a className="authorization__link" href="/authorization">Восстановить пароль</a>
                <a className="authorization__link" href="/registration">Регистрация</a>
            </div>

        </div>
    )
})